<tec-modal
    [isVisible]="showForm"
    [title]="'PANEL.OPERATION_BALANCE.FORM.CONTACT_EXPERT' | translate"
    [buttonPrimaryLabel]="'BUTTON.CONTACT' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="handleFormSubmit($event)"
>
    <ng-container body [formGroup]="form">
        <div class="grid grid-i2">
            <tec-form-group
                [label]="'PANEL.OPERATION_BALANCE.FORM.NAME' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('name'))"
            >
                <tec-input formControlName="name" [hasError]="reactiveFormService.hasError(form.get('name'))" />
            </tec-form-group>

            <tec-form-group
                [label]="'PANEL.OPERATION_BALANCE.FORM.SURNAME' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('surnames'))"
            >
                <tec-input formControlName="surnames" [hasError]="reactiveFormService.hasError(form.get('surnames'))" />
            </tec-form-group>

            <tec-form-group
                [label]="'PANEL.OPERATION_BALANCE.FORM.EMAIL' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('email'))"
            >
                <tec-input formControlName="email" [hasError]="reactiveFormService.hasError(form.get('email'))" />
            </tec-form-group>

            <tec-form-group
                [label]="'PANEL.OPERATION_BALANCE.FORM.PHONE' | translate"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('phone'))"
            >
                <app-phone-input formControlName="phone" [hasError]="reactiveFormService.hasError(form.get('phone'))" />
            </tec-form-group>
        </div>

        <tec-form-group
            [label]="'PANEL.OPERATION_BALANCE.FORM.HELP' | translate"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('message'))"
        >
            <tec-textarea formControlName="message" [hasError]="reactiveFormService.hasError(form.get('message'))" />
        </tec-form-group>
    </ng-container>
</tec-modal>

<!-- MODAL SUCCESS -->
<tec-modal
    type="confirmation"
    [isVisible]="showSuccess"
    [buttonPrimaryLabel]="'BUTTON.OK' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body>
        <tec-tag-icon [status]="'success'" [icon]="'icon-check'" />
        <div class="body__text">
            <h4>{{ 'PANEL.OPERATION_BALANCE.FORM.SUCCESS_MESSAGE' | translate }}</h4>
            <span>{{ 'PANEL.OPERATION_BALANCE.FORM.SUCCESS_DESCRIPTION' | translate }}</span>
        </div>
    </ng-container>
</tec-modal>

<!-- MODAL ERROR -->
<tec-modal
    type="confirmation"
    [isVisible]="showError"
    [buttonPrimaryLabel]="'BUTTON.OK' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body>
        <tec-tag-icon [icon]="'icon-alert'" />
        <div class="body__text">
            <h4>{{ 'PANEL.OPERATION_BALANCE.FORM.ERROR_MESSAGE' | translate }}</h4>
            <span>{{ 'PANEL.OPERATION_BALANCE.FORM.ERROR_DESCRIPTION' | translate }}</span>
        </div>
    </ng-container>
</tec-modal>
